module.exports = __webpack_public_path__ + "img/art_toshimitsu.bfe185e8.png";